import React, { SVGProps } from 'react'

export const WaveUnderlineLongSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height={8}
    fill="none"
    {...props}
  >
    <defs>
      <pattern
        id="wave-underline-longSvg"
        width={40}
        height={8}
        x={0}
        y={0}
        patternUnits="userSpaceOnUse"
      >
        <svg width={40} height={8} viewBox="0 0 40 8" {...props}>
          <path
            fill="#7F7472"
            fillRule="evenodd"
            d="M10.195 4.461c3.264-1.381 6.863-1.96 9.805-1.96 2.942 0 6.541.579 9.805 1.96C33.208 5.901 36.942 6.5 40 6.5V5.499c-2.942 0-6.542-.579-9.806-1.96C26.792 2.099 23.058 1.5 20 1.5c-3.058 0-6.792.599-10.194 2.039C6.542 4.92 2.942 5.499 0 5.499V6.5c3.058 0 6.792-.599 10.195-2.039Z"
            clipRule="evenodd"
          />
        </svg>
      </pattern>
    </defs>
    <rect
      x={0}
      y={0}
      width="100%"
      height="100%"
      fill="url(#wave-underline-longSvg)"
    />
  </svg>
)
